import { SvgIcon } from "@material-ui/core";
import * as React from "react";

function StickMode(props: any) {
  return (
    <SvgIcon
      viewBox="0 0 50 50"
      {...props}
      style={{
        background: props.selected ? "rgb(207, 239, 251)" : "transparent",
        padding: "2px",
        borderRadius: "15%",
      }}
    >
      <circle
        transform="matrix(.13706 0 0 .13553 -59.263 -26.129)"
        cx={732.199}
        cy={249.856}
        r={36.48}
      />
      <circle
        transform="matrix(1.01797 0 0 .99438 -650.928 -333.729)"
        cx={673.58}
        cy={357.855}
        r={3.929}
      />
      <circle
        transform="matrix(1.01797 0 0 .99438 -723.661 -446.88)"
        cx={754.221}
        cy={488.852}
        r={3.929}
      />
      <path d="M44.968 38.987L33.784 21.462l8.203-14.008" strokeWidth={5} />
      <circle
        transform="matrix(1.01797 0 0 .99438 -483.574 -232.525)"
        cx={480.969}
        cy={240.868}
        r={3.929}
      />
      <circle
        transform="matrix(1.01797 0 0 .99438 -477.914 -214.668)"
        cx={480.969}
        cy={240.868}
        r={3.929}
      />
      <circle
        transform="matrix(1.01797 0 0 .99438 -482.816 -196.524)"
        cx={480.969}
        cy={240.868}
        r={3.929}
      />
      <path d="M6.559 7.038l5.347 17.976-5.212 18.214" strokeWidth={5} />
      <path
        d="M8.577 1.758h11.082V-.267l4 3.036-4 3.036V3.781H8.577V1.758z"
        style={{
          transformOrigin: "16.118px 2.769px",
        }}
        transform="rotate(-177.07 3.612 2.177) skewX(-.14)"
      />
      <path
        d="M4.869 2.688h5.562V-.407l3 4.64-3 4.641V5.779H4.869V2.688z"
        style={{
          transformOrigin: "9.15px 4.233px",
        }}
        transform="rotate(176.091 6.598 10.051) skewX(.187)"
      />
      <path
        d="M11.436 1.873h13.596V-.284l6.513 3.234-6.513 3.233V4.027H11.436V1.873z"
        style={{
          transformOrigin: "21.49px 2.95px",
        }}
        transform="rotate(176.091 1.504 19.505) skewX(.187)"
      />
    </SvgIcon>
  );
}

export default StickMode;
